import styled from "styled-components";

// Error message styling
export const ErrorMessageComp = styled.div`
  color: red;
  // margin-top: 10px;
  font-size: 14px;
  text-align:right;
`;